import React from 'react';
import { AppBar } from 'material-ui';
import PropTypes from 'prop-types';
import { StyleSheet, css } from 'aphrodite';

import NewInquiryButton from './NewInquiryButton';
import GlobalSearchBox from './GlobalSearchBox';
import LogoutButton from './LogoutButton';
import OurismanTravelTheme from '../../ourismanTravelTheme';

export default class Header extends React.Component {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]),
    history: PropTypes.shape({
      push: PropTypes.func,
    }).isRequired,
  };

  static defaultProps = {
    children: [],
  }

  render() {
    const { history } = this.props;

    return (<div className={css(styles.headerStyles)}>
      <AppBar showMenuIconButton={false}>
        <div className={css(styles.headerContentStyles)}>
          <div className={css(styles.headerNameStyles)}>
            <img src='/OT_Logo_Mark_Gold.png' height='64' alt='Ourisman Travel' />
            <h1 className={css(styles.headerTitleStyles)}>Ourisman Travel</h1>
          </div>
          <div className={css(styles.headerActionStyles)}>
            <GlobalSearchBox history={history} />
            <NewInquiryButton history={history} />
            <LogoutButton />
          </div>
        </div>
      </AppBar>
      { this.props.children }
    </div>);
  }
}

const styles = StyleSheet.create({
  headerStyles: {
    position: 'fixed',
    width: '100%',
    zIndex: 1000,
  },
  headerActionStyles: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  headerContentStyles: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    position: 'relative',
    left: -16,
    boxSizing: 'content-box',
  },
  headerNameStyles: {
    alignItems: 'center',
    display: 'flex',
    color: OurismanTravelTheme.palette.alternateTextColor,
  },
  headerTitleStyles: {
    margin: 0,
    color: OurismanTravelTheme.palette.alternateTextColor,
    boxSizing: 'content-box',
    fontFamily: 'Noto Sans,sans-serif',
    fontSize: '2em',
    lineHeight: 'inherit',
    '@media (max-width: 925px)': {
      display: 'none',
    },
  },
});



// WEBPACK FOOTER //
// /src/components/Container/Header.js